export default function(instance){
    return{
        getByReportTypeId(payload){
            return instance.get('/ReportTypeCatalog/' + payload.reportTypeId);
        }
    }
}